import { createRef } from 'react'

export const createItemRef = (items) => {
  if (!items) return null

  return items.reduce((acc, cur) => {
    return { ...acc, [cur.id]: createRef() }
  }, {})
}
